import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, FormBuilder, Validators} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {AccessControlService} from 'src/app/services/access-control.service';

@Component({
  selector: 'app-logical-access',
  templateUrl: './logical-access.component.html',
  styleUrls: ['./logical-access.component.css']
})
export class LogicalAccessComponent implements OnInit {
  isLoading = false;
  logicalAccessForm: FormGroup;
  isSavingData = false;
  Host: string;
  clientId = localStorage.getItem('user_id');
  appId: string;

  constructor(private fb: FormBuilder,
              private toastrService: ToastrService,
              private accessService: AccessControlService,
              private ac: ActivatedRoute
  ) {
    this.appId = this.ac.snapshot.params['id'];
    this.Host = this.ac.snapshot.queryParamMap.get('appname')

  }


  ngOnInit() {
    this.addForm();
    this.getUserApplicationAccessData()
  }

  addForm() {
    this.logicalAccessForm = this.fb.group({
      isSet: [false, [Validators.required]],
      URL: ['', [Validators.required]]
    })
  }

  getUserApplicationAccessData() {
    this.isLoading = true;
    this.accessService.getUserApplicationAccess({appId: this.appId, clientId: this.clientId}).subscribe(
      {
        next: (res: any) => {
          if (res.error) {
            this.toastrService.error(res.error)
          } else
            this.logicalAccessForm.setValue({
              URL: res.data.URL||'',
              isSet: res.data.isSet||false
            })
          this.isLoading = false;
        },
        error: (err) => {
          this.toastrService.error(err.message)
          this.isLoading=false;
          this.logicalAccessForm.setValue({
            URL: '',
            isSet:false
          })
        }
      }
    )
  }

  onSubmit(form: FormGroup) {
    this.isSavingData = true;
    this.accessService.addUserApplicationAccess(form.value, {appId: this.appId, clientId: this.clientId}).subscribe(
      {
        next: (res: any) => {
          if (res.error) {
            this.toastrService.error(res.error);
          } else
            this.toastrService.success(res.message)
          this.isSavingData = false;
        },
        error: (err) => {
          this.toastrService.error(err.message);
          this.isSavingData = false;
        }
      }
    )
  }

}
